import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import { DriveNinjaTemplate } from './index';
import brandConfig from '../../../branding/configFactory';

import useTranslatedField from '../../hooks/useTranslatedField';
import ComparisonProvider from '../../../contexts/comparison';
import BrandProvider from '../../../contexts/branding';

const DNGatsbyTemplate = (props) => {
  const data = useStaticQuery(graphql`
      query SiteMenuQuery {
          allDriveNinjaFooterMenuType {
              edges {
                  node {
                      id
                      translatedName {
                          ...translatedField
                      }
                      orderingPriority
                      entries {
                          edges {
                              node {
                                  translatedLinkText {
                                      ...translatedField
                                  }
                                  translatedLinkTitle {
                                      ...translatedField
                                  }
                                  href
                                  id
                                  orderingPriority
                                  to
                              }
                          }
                      }
                  }
              }
          }
          allDriveNinjaHeaderMenuEntryType {
              edges {
                  node {
                      href
                      id
                      translatedLinkText {
                          ...translatedField
                      }
                      translatedLinkTitle {
                          ...translatedField
                      }
                      orderingPriority
                      to
                  }
              }
          }
          allDriveNinjaDrawerMenuEntryType {
              edges {
                  node {
                      href
                      id
                      translatedLinkText {
                          ...translatedField
                      }
                      translatedLinkTitle {
                          ...translatedField
                      }
                      orderingPriority
                      to
                  }
              }
          }
      }
  `);

  const t = useTranslatedField();

  const linkSort = (a, b) => a.orderingPriority === b.orderingPriority ? t(a, 'linkText').localeCompare(t(b, 'linkText')) : a.orderingPriority - b.orderingPriority;
  const nameSort = (a, b) => a.orderingPriority === b.orderingPriority ? t(a, 'name').localeCompare(t(b, 'name')) : a.orderingPriority - b.orderingPriority;

  const drawerMenuItems = data?.allDriveNinjaDrawerMenuEntryType?.edges?.map(n => n.node).sort(linkSort).map(({
    id,
    to,
    href,
    ...rest
  }) => ({
    id,
    linkText: t(rest, 'translatedLinkText'),
    linkTitle: t(rest, 'translatedLinkTitle'),
    url: to || href
  }));

  const headerMenuItems = data?.allDriveNinjaHeaderMenuEntryType?.edges?.map(n => n.node).sort(linkSort).map(({
    id,
    to,
    href,
    ...rest
  }) => ({
    id,
    linkText: t(rest, 'translatedLinkText'),
    linkTitle: t(rest, 'translatedLinkTitle'),
    url: to || href
  }));

  // console.log({ brandConfig });
  const footerMenus = data?.allDriveNinjaFooterMenuType?.edges?.map(n => n.node).sort(nameSort).map(({
    id,
    entries,
    ...rest
  }) => ({
    id,
    name: t(rest, 'translatedName'),
    items: entries.edges?.map(n => n.node).sort(linkSort).map(({ id, to, href, ...rest }) => ({
      id,
      linkText: t(rest, 'translatedLinkText'),
      linkTitle: t(rest, 'translatedLinkTitle'),
      url: to || href
    }))
  }));

  const { SiteHeaderImage } = brandConfig;
  const options = {
    drawerMenuItems,
    headerMenuItems,
    siteHeaderImage: <SiteHeaderImage />,
    footerMenus,
    ...props

  };

  return <ComparisonProvider>
    <BrandProvider brandConfig={brandConfig}>
      <DriveNinjaTemplate {...options} />
    </BrandProvider>
  </ComparisonProvider>;
};

DNGatsbyTemplate.propTypes = {
  ...DriveNinjaTemplate.propTypes
};

export { DNGatsbyTemplate };